import React from "react";
import { getDateTimeString, getCourseDateFormat } from "lib/utils";

const CourseDates = ({ course, languageContext }) => {
  const displayDates =
    course.courseStarts && course.courseStarts !== "0001-01-01T00:00:00";

  const startdateFormat = getCourseDateFormat(course.courseStarts);
  const enddateFormat = getCourseDateFormat(course.courseEnds);

  if (!displayDates) return null;
  return (
    <div>
      <div>
        <span className="fa fa-calendar" />
        {` ${languageContext("startdate")}: ${getDateTimeString(course.courseStarts, startdateFormat)}`}
      </div>
      <div>
        <span className="fa fa-calendar" />
        {` ${languageContext("enddate")}: ${getDateTimeString(course.courseEnds, enddateFormat)}`}
      </div>
    </div>
  );
};

export default CourseDates;
